module.exports = __webpack_public_path__ + "static/media/related-pro-img3.8a8560de.jpg";